<mat-dialog-content class='stack-manager-container'>
    <div *ngFor='let call of calls; let i = index'>
        <se-iframe-call
            (callEnd)='onCallEnd($event)'
            (callThrowError)='onCallError($event)'
            *ngIf='showModalWindowUrlCall(call, i)'
            [debug]='debug'
            [call]='call'
            [dataStore]='dataStore'
        ></se-iframe-call>
        <se-form-call
            *ngIf='showFormCall(call, i)'
            (callEnd)='onCallEnd($event)'
            (callThrowError)='onCallError($event)'
            [call]='call'
            [debug]='debug'
            [dataStore]='dataStore'>
        </se-form-call>
        <se-tab-window-call
            (callEnd)='onCallEnd($event)'
            (callThrowError)='onCallError($event)'
            *ngIf='showTabWindowUrlCall(call, i)'
            [debug]='debug'
            [call]='call'
            [dataStore]='dataStore'
        ></se-tab-window-call>
        <se-rest-call
            (callEnd)='onCallEnd($event)'
            (callThrowError)='onCallError($event)'
            *ngIf='showRestCall(call, i)'
            [call]='call'
            [debug]='debug'
            [dataStore]='dataStore'
        ></se-rest-call>
        <se-array-find-call
            (callEnd)='onCallEnd($event)'
            (callThrowError)='onCallError($event)'
            *ngIf='showArrayFindCall(call, i)'
            [call]='call'
            [debug]='debug'
            [dataStore]='dataStore'>
        </se-array-find-call>
        <se-error-call
            (callEnd)='onCallEnd($event)'
            (callThrowError)='onCallError($event)'
            *ngIf='showErrorCall(call, i)'
            [call]='call'
            [debug]='debug'
            [dataStore]='dataStore'
        >
        </se-error-call>

    </div>
</mat-dialog-content>
